import { URL_MAP } from "@/constant/urlConstant";

export interface RouteMeta {
  pathname: string;
  title?: string;
  logo?: boolean;
  back?: boolean;
  notification?: boolean;
  register?: boolean;
  signin?: boolean;
  search?: boolean;
  home?: boolean;
  bottomNavigation?: boolean;
}

export const routeMetaData: RouteMeta[] = [
  {
    pathname: "/",
    logo: true,
    search: true,
    notification: true,
    bottomNavigation: true,
    signin: true,
    register: true,
  },
  {
    pathname: URL_MAP.SIGNUP_INTEGRATED,
    title: "통합 회원 가입",
    back: true,
  },
  {
    pathname: URL_MAP.SIGNUP_STEP0,
    title: "직업 선택",
    back: true,
  },
  {
    pathname: URL_MAP.SIGNUP_STEP1,
    title: "기본 정보",
    back: true,
  },
  {
    pathname: URL_MAP.SIGNUP_STEP2,
    title: "추가 정보",
    back: true,
  },
  {
    pathname: URL_MAP.PHONE_VERIFY,
    title: "본인 인증",
    back: true,
  },
  {
    pathname: URL_MAP.POST,
    title: "게시판",
    notification: true,
    search: true,
    bottomNavigation: true,
  },
  {
    pathname: URL_MAP.POST_ARTICLE,
    back: true,
    home: true,
    notification: true,
  },
  {
    pathname: URL_MAP.POST_WRITE,
    title: "게시글 작성",
    back: true,
    home: true,
  },
  {
    pathname: URL_MAP.POST_MODIFY,
    title: "게시글 수정",
    back: true,
    home: true,
  },
  {
    pathname: URL_MAP.QNA_RANKING,
    title: "순위 보기",
    back: true,
  },
  {
    pathname: "/qna",
    title: "Q&A/임상",
    search: true,
    notification: true,
    bottomNavigation: true,
  },
  {
    pathname: URL_MAP.QNA,
    title: "Q&A/임상",
    search: true,
    notification: true,
    bottomNavigation: true,
  },
  {
    pathname: URL_MAP.QNA_ARTICLE,
    back: true,
    home: true,
    notification: true,
  },
  {
    pathname: URL_MAP.QNA_WRITE,
    title: "Q&A 작성",
    back: true,
    home: true,
  },
  {
    pathname: "/qna/modify/:tab/:bid",
    title: "Q&A 수정",
    back: true,
    home: true,
  },
  {
    pathname: "/forum",
    title: "Q&A/임상",
    search: true,
    notification: true,
    bottomNavigation: true,
  },
  {
    pathname: "/forum/article/:bid",
    back: true,
    home: true,
    notification: true,
  },
  {
    pathname: "/forum/write/:tab",
    title: "임상포럼 작성",
    back: true,
    home: true,
  },
  {
    pathname: "/forum/modify/:bid",
    title: "임상포럼 수정",
    back: true,
    home: true,
  },
  {
    pathname: "/forum/ranking",
    title: "순위 보기",
    back: true,
  },
  {
    pathname: "/alarm",
    title: "알림",
    back: true,
  },
  {
    pathname: "/management/consulting",
    title: "개원/경영",
    search: true,
    notification: true,
    bottomNavigation: true,
  },
  {
    pathname: "/class",
    title: "클래스",
    back: true,
    bottomNavigation: true,
  },
  {
    pathname: "/class/course/:id",
    title: "클래스",
    back: true,
  },
  {
    pathname: "/class/search",
    title: "클래스",
    back: true,
  },
  {
    pathname: "/class/curation/:id",
    title: "기획전",
    back: true,
  },
  {
    pathname: "/shurink",
    title: "슈링크",
    back: true,
    home: true,
  },
  {
    pathname: "/contents",
    title: "콘텐츠",
    search: true,
    notification: true,
    bottomNavigation: true,
  },
  {
    pathname: "/contents/article/:bid",
    back: true,
    notification: true,
  },
  {
    pathname: "/contents/search",
    title: "콘텐츠",
    search: true,
    notification: true,
    bottomNavigation: true,
  },
  {
    pathname: "/mypage/modify/*",
    title: "회원정보 수정",
    back: true,
    bottomNavigation: true,
  },
  {
    pathname: "/mypage/point/*",
    title: "포인트 내역",
    back: true,
    bottomNavigation: true,
  },
  {
    pathname: "/mypage/*",
    title: "마이페이지",
    back: true,
    bottomNavigation: true,
  },
  {
    pathname: "/management/consulting/:id",
    title: "컨설팅",
    back: true,
    bottomNavigation: true,
  },
  {
    pathname: "/management/estate/write",
    title: "양도/임대 글 작성",
    back: true,
    home: true,
  },
  {
    pathname: "/management/estate/modify/:bid",
    title: "양도/임대 글 수정",
    back: true,
    home: true,
  },
  {
    pathname: "/management/estate/:bid",
    back: true,
    notification: true,
  },
  {
    pathname: "/management/seminar/write",
    title: "세미나 작성",
    back: true,
    home: true,
  },
  {
    pathname: "/management/seminar/modify/:bid",
    title: "세미나 수정",
    back: true,
    home: true,
  },
  {
    pathname: "/management/market/write",
    title: "중고거래 글 작성",
    back: true,
    home: true,
  },
  {
    pathname: "/management/market/modify/:bid",
    title: "중고거래 글 수정",
    back: true,
    home: true,
  },
  {
    pathname: "/management/market/:bid",
    back: true,
    home: true,
    notification: true,
  },
  {
    pathname: "/management/*",
    title: "개원/경영",
    search: true,
    notification: true,
    bottomNavigation: true,
  },
  {
    pathname: "/edu",
    back: true,
    home: true,
    notification: true,
    bottomNavigation: true,
  },
  {
    pathname: "/expo",
    title: "상영관",
    back: true,
  },
  {
    pathname: "/profile/*",
    back: true,
    home: true,
    notification: true,
  },
  {
    pathname: "/recruit/doctor",
    title: "구인구직",
    search: true,
    notification: true,
    bottomNavigation: true,
  },
  {
    pathname: "/recruit/doctor/write",
    title: "구인글 작성",
    back: true,
    home: true,
  },
  {
    pathname: "/recruit/doctor/modify/:id",
    title: "구인글 수정",
    back: true,
    home: true,
  },
  {
    pathname: "/recruit/doctor/:bid",
    back: true,
    home: true,
    notification: true,
  },
  {
    pathname: "/footer/service",
    title: "이용약관",
    back: true,
  },
  {
    pathname: "/footer/privacy",
    title: "개인정보처리방침",
    back: true,
  },
  {
    pathname: "/footer/financialTransactionTerms",
    title: "전자금융거래약관",
    back: true,
  },
  {
    pathname: "/hermannryff",
    title: "허먼리프",
    back: true,
    home: true,
  },
  {
    pathname: "/festival/*",
    title: "전치제",
    back: true,
    home: true,
    bottomNavigation: true,
  },
  {
    pathname: "/search",
    title: "검색",
    back: true,
    bottomNavigation: true,
  },
  {
    pathname: "/expo/*",
    title: "상영관",
    back: true,
    bottomNavigation: true,
  },
  {
    pathname: "/ai/*",
    title: "모어덴 AI",
    back: true,
  },
  {
    pathname: "/findid/*",
    title: "아이디 찾기",
    back: true,
    home: true,
  },
  {
    pathname: "/findpw/*",
    title: "비밀번호 찾기",
    back: true,
    home: true,
  },
  {
    pathname: "/verifyPending",
    title: "회원 인증",
    back: true,
    home: true,
  },
  {
    pathname: "/syncAccount",
    title: "계정 연동",
    back: true,
    home: true,
  },
];

export const defaultRouteMeta: RouteMeta = {
  pathname: "",
  title: "",
  logo: true,
  back: false,
  notification: false,
  register: false,
  signin: false,
  bottomNavigation: false,
};
